import React, { Component, Fragment } from 'react';
import {
    createFormData,
    extractQuestionAnswer,
    generateQuestionSchema,
    getNextQuestionId,
} from '../../helpers/QuestionnaireHelper';
import {
    fetchAnalysis,
    saveAnalysis,
    setCurrentQuestion,
    suspendAnalysis,
} from '../state/actions/AnalysisActions';

import { AnalysisDocumentsBrowser } from './AnalysisDocuments';
import { Error } from '../shared/Error/Error';
import Form from 'react-jsonschema-form';
import { History } from '../../helpers/History';
import { LoadingIndicator } from '../shared/LoadingIndicator/LoadingIndicator';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import { bindActionCreators } from 'redux';
import { cloneDeep } from 'lodash';
import { connect } from 'react-redux';

// COMPONENT
class AnalysisQuestion extends Component {
    constructor(props) {
        super(props);

        this.refresh = this.refresh.bind(this);
    }

    componentDidMount() {
        const { fetchAnalysis } = this.props;

        fetchAnalysis();
        //window.addEventListener('focus', this.refresh, false);

        this.intervalRef = window.setInterval(this.onQuestionChange, 500);
    }

    componentWillUnmount() {
        //window.removeEventListener('focus', this.refresh, false);
        window.clearInterval(this.intervalRef);
    }

    refresh() {
        const { fetchAnalysis } = this.props;
        fetchAnalysis();
    }

    onQuestionChange = questionId => {
        const { analysis, currentQuestion } = this.props;

        this.clearNodeColors();

        if (!questionId) {
            if (currentQuestion) {
                const questionNode = document.getElementById(currentQuestion.id);
                if (questionNode) {
                    window.clearInterval(this.intervalRef);
                    questionNode.scrollIntoView();

                    if (analysis.questionLog) {
                        for (let i = 0; i < analysis.questionLog.length; i++) {
                            this.changeNodeColor(analysis.questionLog[i], '#e8e8e8');
                        }
                    }
                    this.changeNodeColor(currentQuestion.id, '#d5f5e3');
                }
            }
        } else {
            const questionNode = document.getElementById(questionId);
            if (questionNode) {
                questionNode.scrollIntoView();

                if (analysis.questionLog) {
                    for (let i = 0; i < analysis.questionLog.length; i++) {
                        this.changeNodeColor(analysis.questionLog[i], '#e8e8e8');
                    }
                }
                this.changeNodeColor(questionId, '#d5f5e3');
            }
        }
    };

    clearNodeColors = () => {
        // g 'node clickable base'
        const nodes = document.getElementsByClassName('node clickable base');
        Array.from(nodes).forEach(node => {
            node.getElementsByTagName('rect')[0].setAttribute('style', 'fill: #FFF !important');
        });
    };

    changeNodeColor = (nodeId, color) => {
        const node = document.getElementById(nodeId);

        if (node) {
            node.getElementsByTagName('rect')[0].setAttribute('style', `fill: ${color} !important`);
        }
    };

    onSubmit = formData => {
        const { analysis, currentQuestion, saveAnalysis, setCurrentQuestion } = this.props;

        // extract answer from formData
        const extractedAnswer = extractQuestionAnswer(currentQuestion, formData.formData);

        // modify answer chain
        if (!analysis.answers || !(analysis.answers instanceof Array)) {
            analysis.answers = [];
        }

        analysis.answers.push({ questionId: currentQuestion.id, answer: extractedAnswer });

        // modify tag chain
        if (!analysis.tags || !(analysis.tags instanceof Array)) {
            analysis.tags = [];
        }

        analysis.tags.push({
            questionId: currentQuestion.id,
            tagId: null,
        });

        // update question log
        if (analysis.questionLog && analysis.questionLog instanceof Array) {
            analysis.questionLog.push(currentQuestion.id);
        } else {
            analysis.questionLog = [currentQuestion.id];
        }

        // get next question in chain
        const nextQuestionId = getNextQuestionId(currentQuestion, extractedAnswer);

        if (nextQuestionId) {
            saveAnalysis(analysis)
                .then(() => {
                    // find and set next question
                    const nextQuestion = analysis.questions.find(question => {
                        if (question.id === nextQuestionId) {
                            return question;
                        }
                    });

                    if (nextQuestion) {
                        setCurrentQuestion(nextQuestion);
                        this.onQuestionChange(nextQuestion.id);
                    } else {
                        Swal({
                            title: 'Oops...',
                            type: 'error',
                            text: `Unable to find the next question ('${nextQuestionId}')`,
                        }).then(() => {
                            History.push('/');
                        });
                    }
                })
                .catch(error => {
                    Swal({
                        title: 'Oops...',
                        type: 'error',
                        text: error,
                    }).then(() => {
                        History.push('/');
                    });
                });
        } else {
            if (analysis.adminLocked || (analysis.documents && analysis.documents.length)) {
                this.completeAnalysis();
            } else {
                Swal({
                    title: 'No Documents Added',
                    text: "Are you sure you're ready to complete this analysis?",
                    type: 'warning',
                    showCancelButton: true,
                }).then(result => {
                    if (result.value) {
                        this.completeAnalysis();
                    }
                });
            }
        }
    };

    completeAnalysis = () => {
        const { analysis, saveAnalysis } = this.props;

        // set the completed flag
        analysis.completed = true;

        saveAnalysis(analysis).then(() => {
            Swal({
                title: 'Analysis complete',
                type: 'success',
            })
                .then(() => {
                    History.push('/');
                })
                .catch(error => {
                    Swal({
                        title: 'Oops...',
                        type: 'error',
                        text: error,
                    }).then(() => {
                        History.push('/');
                    });
                });
        });
    };

    /*onValidate = (formData, errors) => {
        const {documentSelection, currentQuestion, documentSelectionNotFound} = this.props;

        if(!documentSelectionNotFound && currentQuestion.taggable &&
            (!documentSelection
                || !documentSelection.start
                || !documentSelection.end
                || !documentSelection.text
                || documentSelection.text.length === 0)
        ) {
            errors.formControl ?
                errors.formControl.addError('Document text selection is required') :
                errors.addError('Document text selection is required');
        }

        return errors;
    };*/

    transformErrors = errors => {
        return errors.map(error => {
            switch (error.message) {
                case 'should be array':
                    error.message = 'Must select at least one';
                    break;
                case 'should be equal to one of the allowed values':
                    error.message = 'Selection of one option is required';
                    break;
            }

            return error;
        });
    };

    onNavigateToPrevious = () => {
        const { analysis, saveAnalysis, setCurrentQuestion } = this.props;

        // find previous answer and reverse previous results
        const previousQuestionId = analysis.questionLog.pop();
        const lastAnswer = analysis.answers.pop();

        // save new state
        saveAnalysis(analysis)
            .then(() => {
                // find and set previous question
                const previousQuestion = analysis.questions.find(question => {
                    if (question.id === previousQuestionId) {
                        return question;
                    }
                });

                // carry last answer given in question
                const previousQuestionClone = cloneDeep(previousQuestion);
                previousQuestionClone.lastAnswer = lastAnswer;

                setCurrentQuestion(previousQuestionClone);

                this.onQuestionChange(previousQuestion.id);
            })
            .catch(error => {
                Swal({
                    title: 'Oops...',
                    type: 'error',
                    text: error,
                }).then(() => {
                    History.push('/');
                });
            });
    };

    cantCompleteReview = () => {
        Swal({
            title: 'Cannot Complete Review',
            type: 'warning',
            input: 'text',
            showCancelButton: true,
            focusConfirm: false,
            footer: 'Clicking "OK" will put this review on hold and force an administrator review.',
            inputValidator: value => {
                value = value.trim();
                return (
                    value.trim() === '' &&
                    'Please describe why you are unable to complete the review.'
                );
            },
        }).then(result => {
            if (result.dismiss) {
                return;
            }
            const { suspendAnalysis } = this.props;
            const { analysis } = this.props;
            const { analysisId } = analysis;
            const { value: reason } = result;

            return suspendAnalysis(analysisId, reason)
                .then(() => {
                    History.push('/');
                })
                .catch(error => {
                    console.error(error.message);
                    Swal({
                        title: 'Oops...',
                        type: 'error',
                        text: 'Unable to suspend analysis, please contact an administrator.',
                    }).then(() => {
                        History.push('/');
                    });
                });
        });
    };

    onInfoClick = questionId => {
        const { analysis } = this.props;

        questionId =
            questionId.split('-').length > 3
                ? questionId.split('-').slice(1, 4).join('-')
                : questionId;

        // find and set next question
        const question = analysis.questions.find(question => question.id === questionId);

        // find answer, if available
        const answer = analysis.answers.find(answer => {
            if (answer.questionId === questionId) return true;
        });

        let answerVal = '';
        if (answer) {
            if (question.input.type === 'boolean') {
                answerVal = answer.answer ? 'yes' : 'no';
            } else {
                answerVal = answer.answer;
            }
        }

        const answerText = answer && `<dt>Answer(s) Given</dt><dd>${answerVal}</dd>`;

        Swal({
            title: questionId,
            type: 'info',
            html: `
                <dl>
                <dt>Section</dt>
                <dd>${question.section} - ${question.subsection}</dd>
                <dt>Title</dt>
                <dd>${question.title}</dd>
                <dt>Description</dt>
                <dd>${question.description}</dd>
                <dt>Control Type</dt>
                <dd>${question.input.type}</dd>
                <dt>Next Question(s)</dt>
                <dd>${question.input.nextQuestion.join(' | ')}</dd>
                ${answerText || ''}
            `,
        });
    };

    render() {
        const { currentQuestion, analysis, fetched, failed, fetching } = this.props;

        if (!fetched) {
            return <LoadingIndicator busy={fetching} />;
        } else if (failed) {
            return <Error message="Failed to fetch analysis record" />;
        } else if (analysis && currentQuestion) {
            const question = generateQuestionSchema(currentQuestion);

            let website;
            if (analysis.product && analysis.product.website) {
                website = analysis.product.website;
            } else if (analysis.vendor && analysis.vendor.website) {
                website = analysis.vendor.website;
            }

            //const documentKeys = Object.keys(analysis.documents);

            // check if this was a previous nav, if so, set answer value
            let formData = null;
            if (currentQuestion.lastAnswer) {
                formData = createFormData(currentQuestion, currentQuestion.lastAnswer.answer);
            }

            return (
                <Fragment>
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="d-flex justify-content-between">
                                <div>
                                    {analysis.name ? analysis.name : ''}{' '}
                                    <small className="text-muted">
                                        {question.section} - {question.subsection}
                                    </small>
                                </div>
                                <a href={website} target="_blank" rel="noopener noreferrer">
                                    website
                                </a>
                                <i
                                    className="fas fa-info-circle float-right"
                                    onClick={() => this.onInfoClick(question.id)}
                                />
                            </div>
                        </div>
                        <div className="card-body">
                            <Form
                                schema={question.schema}
                                uiSchema={question.uiSchema}
                                onSubmit={this.onSubmit}
                                showErrorList={false}
                                validate={this.onValidate}
                                formData={formData}
                                transformErrors={this.transformErrors}
                            >
                                <div>
                                    {website && currentQuestion.includeWebsiteLink && (
                                        <div className="mb-3">
                                            <a
                                                href={website}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                website
                                            </a>
                                        </div>
                                    )}
                                    <div>
                                        {analysis.questionLog &&
                                            analysis.questionLog.length > 0 && (
                                                <button
                                                    type="button"
                                                    onClick={this.onNavigateToPrevious}
                                                    className="btn btn-secondary mb-2"
                                                >
                                                    Previous
                                                </button>
                                            )}
                                        <button
                                            className="btn btn-primary mb-2 float-right"
                                            type="submit"
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        </div>
                        <div className="card-footer">
                            <div className="row mt-3">
                                <div className="col text-center">
                                    <button
                                        onClick={this.cantCompleteReview}
                                        className="btn btn-sm btn-outline-secondary"
                                    >
                                        Cannot complete review
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <AnalysisDocumentsBrowser analysis={analysis} />
                </Fragment>
            );
        } else {
            return null;
        }
    }
}

AnalysisQuestion.propTypes = {
    fetchAnalysis: PropTypes.func.isRequired,
    saveAnalysis: PropTypes.func.isRequired,
    setCurrentQuestion: PropTypes.func.isRequired,
    suspendAnalysis: PropTypes.func.isRequired,
    fetched: PropTypes.bool.isRequired,
    fetching: PropTypes.bool.isRequired,
    analysis: PropTypes.object,
    currentQuestion: PropTypes.object,
    failed: PropTypes.bool,
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { fetching, fetched, failed, analysis, currentQuestion } = state.analysis;

    return { fetching, fetched, failed, analysis, currentQuestion };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        { suspendAnalysis, fetchAnalysis, saveAnalysis, setCurrentQuestion },
        dispatch
    );

const hoc = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
    AnalysisQuestion
);

// EXPORT COMPONENT
export { hoc as AnalysisQuestion };
